export default {
  system: '均胜维修系统管理平台',
  lang: 'zh',
  //基础
  base: {
    search: '搜索',
    query: '查询',
    clear: '清空',
    open: '展开',
    close: '关闭',
    add: '新增',
    detail: '详情',
    update: '修改',
    delete: '删除',
    remove: '移除',
    save: '保存',
    empty: '清空',
    confirm: '确认',
    cancel: '取消',
    role: '角色',
    user: '用户',
    auth: '权限',
    system: '系统',
    group: '目录',
    page: '页面',
    name: '名称',
    phone: '手机号',
    email: '邮箱',
    account: '账号',
    empNumber: '工号',
    baseinfo: '基本信息',
    personal: '个人信息',
    loadFailed: '加载失败',
    datalist: '数据列表',
    treelist: '树状列表',
    emptydata: '暂无数据',
    memberManage: '成员管理',
    authAssign: '权限分配',
    roleAssign: '角色分配',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    checkPassword: '确认密码',
    export: '导出',
    operation: '操作',
    ifEnable: '是否启用',
    Enable: '启用',
    Disable: '不启用',
    exit: '退出',
    PleaseSelect: '请选择',
    PleaseEnter: '请输入',
    SuccessfullyAdded: '新增成功!!!',
    SuccessfullyUpdated: '修改成功!!!',
    order: '序号',
    Reset: '重置',
    Mould: '模板',
    Import: '导入',
    ImportSucceeded: '导入成功',
    JobNo: '工号',
  },
  //机构
  mechanism: {
    mechanismList: '机构列表',
    Organization: '机构名称',
    factoryDomain: '工厂域',
    factoryCode: '工厂编码',
    factoryAddress: '工厂地址',
    factoryID: '工厂ID',
    shopCode: '车间编码',
    shopName: '车间名称',
    sectionCode: '工段编码',
    sectionName: '工段名称',
    lineCode: '产线编码',
    lineName: '产线名称',
    SAPLineCode: 'SAP产线编码',
    AddShop: '新增车间',
    AddSection: '新增工段',
    AddLine: '新增产线',
    UpdateShop: '修改车间',
    UpdateSection: '修改工段',
    UpdateLine: '修改产线',
    selectFc: '请先选择工厂',
    mechanismInfo: '机构信息',
  },
  //班次
  Shift: {
    ShiftList: '班次列表',
    factory: '所属工厂',
    ShiftCode: '班次编码',
    Shift: '班次',
    startTime: '班次开始时间',
    endTime: '班次结束时间',
    scShift: '所属班次',
    HH: '（时）',
    mm: '（分）',
    ShiftInfo: '班次信息',
  },
  //部门
  Branch: {
    BranchCode: '部门编码',
    BranchName: '部门名称',
    BranchList: '部门列表',
  },
  //科室
  Department: {
    DepartmentCode: '科室编码',
    DepartmentName: '科室名称',
    DepartmentList: '科室列表',
    DepartmentImport: '科室导入',
  },
  //员工
  Staff: {
    Staffid: '员工工号',
    StaffName: '员工名称',
    StaffList: '员工列表',
    AddStaff: '添加员工',
    duty: '职务',
    AppointForeman: '委任班组长',
    CancelForeman: '取消班组长',
    Foreman: '班组长',
    selectStaff: '请选择至少一个员工',
    isTips: '是否确定委任该组班长, 是否继续?',
    notTips: '是否确定卸任该组班长, 是否继续?',
  },
  //用户
  User: {
    state: '状态',
    WeChat: '是否绑定企业微信',
    UserList: '用户列表',
    Yes: '是',
    No: '否',
    UserImport: '用户导入',
    Tips: '是否确定重置该数据, 是否继续?',
    noWX: '此用户未注册企业微信',
    input: '请输入(必填)',
    select: '请选择(必填)',
    AddRole: '新增角色',
    RoleName: '角色名称',
    workshop: '所属车间',
    section: '所属工段',
    productLine: '所属产线',
    RoleLevel: '角色级别',
    name: '请输入姓名！！！',
    JobNo: '请输入工号！！！',
    create: '至少创建一个角色',
    added: '此角色已添加',
    gcLevel: '工厂级',
    cjLevel: '车间级',
    gdLevel: '工段级',
    cxLevel: '产线级',
    UserInfo: '用户信息',
  },
  //角色
  Role: {
    RoleCode: '角色编码',
    createTime: '创建时间',
    RoleList: '角色列表',
    RoleEdit: '安灯角色权限编辑',
    Submit: '选择提交',
    select: '请选择安灯对象！！！',
    RoleInfo: '角色信息',
  },
  //枚举类型
  EnumType: {
    EnumType: '枚举类型',
    code: '编码',
    DeviceFiles: '设备文件',
    ToolStatus: '工装状态',
    type: '类型',
  },
  //备件管理
  Account: {
    spareSort: '备件分类',
    unit: '单位',
    sort: '分类',
    spareName: '备件名称',
    spareCode: '备件编码',
    spareBrand: '备件品牌',
    spareModel: '备件型号',
    remark: '备注',
    spareSortName: '备件分类名称',
    safetyStock: '安全库存',
    currentStock: '当前库存',
    stockCeil: '库存上限',
    currentState: '当前状态',
    stockState: '库存状态',
    price: '单价',
    supplierCode: '供应商编号',
    supplierName: '供应商名称',
    spareImport: '备件导入',
    spareInfo: '备件台账信息',
  
    CostCenter: '成本中心',
    annex: '附件',
    spareRecord: '备件记录',
    operationLog: '操作日志',
    operator: '操作人',
    operationTime: '操作时间',
    operationType: '操作类型',
    operationDesc: '操作内容',
    storeName: '仓库名称',
    storeCode: '仓库编码',
    storeManage: '仓库管理',
    region: '区域',
    storeInfo: '仓库信息',
    locatorCode: '库位编码',
    locatorList: '库位列表',
    locatorUniqueCode: '库位唯一码',
    locatorName: '库位名称',
    batchNo: '批次号',
    allot: '调拨',
    nowBatchNo: '当前批次号',
    nowLocatorNum: '当前库位数量',
    allotNum: '调拨数量',
    nowLocator: '当前库位',
    Transfer: '调拨数量不能大于当前库存！',
    kwbnxt: '库位不能相同！',
    tbcg: '调拨成功！',
    SpareStockInfo: '备件库存信息',
    spareOrder: '备件订单',
    Finish: '完成',
    Purchase: '采购',
    waringTime: '提醒日期',
    arrivalTime: '预计日期',
    purchaseOrderCode: '采购订单号',
    unselected: '未选择',
    selected: '已选择',
    enter: '请输入编号（区分大小写）',
    specify: '请详细说明采购状态情况',
    selectCk: '请选择仓库！',
    receiptType: '入库类型',
    receiptCode: '入库单号',
    receiptTime: '入库日期',
    receiptInfo: '入库信息',
    preparedBy: '制单人',
    number: '数量',
    totalPrice: '总价',
    receiptRecord: '入库记录',
    startTime: '开始日期',
    endTime: '结束日期',
    system: '系统自动生成',
    RMB: '元',
    receiptNum: '入库数量',
    useType: '使用类型',
    useCode: '使用编码',
    deliveryCode: '出库单号',
    deliveryTime: '出库日期',
    deliveryInfo: '出库信息',
    deliveryType: '出库类型',
    deliveryNum: '出库数量',
    deliveryRecord: '出库记录',
    recipient: '领用人',
    lampCode: '安灯编码',
    planMaintenanceCode: '计划保养编码',
  },
  //菜单
  menu: {
    person: '个人中心',
    MasterData: '主数据管理',
    ChangeInfo: '修改信息',
    Password: '密码不能小于6位',
    empty: '密码不能为空!',
    Scan: '是否扫码',
  },
  //提示语句
  msg: {
    cleared: '已清空',
    successful: '操作成功',
    pleaseSelectTheRoleOnTheLeft: '请选择左侧角色',
    accountorpasswordemty: '账号密码不能为空',
    Tips: '提示',
    TipsText: '是否确定删除该数据, 是否继续?',
    cancel: '已取消删除',
    canceled: '已取消操作',
    Drag: '将文件拖到此处，或',
    Upload: '点击上传',
    longTips: '是否确定删除该科室,同时会清除该科室员工的部门科室信息, 是否继续?',
    DeletionSucceeded: '删除成功！！！',
    DeleteFailed: '删除失败！！！',
    max: '上传文件大小不能超过5MB！',
    zero: '数量不能为零！',
    spare: '请选择备件！',
    locator: '请选择库位！',
    same: '备件不能有相同的库位、批次号！',
    receipt: '请添加入库单！',
    noStock: '该备件没有库存是否添加？',
    empty: '当前库存为空,请选择别的库位！',
    greater: '出库数量不能大于当前库存！',
    delivery: '请添加出库单！',
  },
  //以下为demo案例======================
  demo: {
    //菜单
    menu: {
      HomePage: '首页',
      MasterData: '主数据管理',
      factorySparePart: '工厂备件',
      Mechanism: '机构',
      Shift: '班次',
      Branch: '部门',
      Department: '科室',
      User: '用户',
      Role: '角色',
      EnumType: '枚举类型',
      Personal: '个人中心',
      Process: '流程管理',
      Staff: '员工',
      AddUser: '用户新增',
      EditUser: '用户编辑',
      AllLog: '日志记录',
      SpareParts: '备件管理',
      SpareAccount: '备件台账',
      SpareType: '备件类型',
      SpareStore: '备件仓库',
      SpareStock: '备件库存',
      SparePurchase: '备件采购提醒',
      SpareWarehouse: '备件入库',
      SpareIssue: '备件出库',
      SpareRecord: '备件出入库记录',
      SpareLocation: '库位',
      SpareEdit: '编辑备件',
      AddReceiptOrder: '添加入库单',
      AddDeliveryOrder: '添加出库单',
    },
  },
}
